<div *ngIf="!checkedLoading" class="page-loading">
    <div class="c-loader"></div>
    <h1>Carregando...</h1>
</div>
<div *ngIf="!checkedGuid && checkedLoading" class="page-not-found">
    <h1>
        <mat-icon class="icon-page" aria-hidden="false" aria-label="web_asset_off">web_asset_off</mat-icon>Página não
        encontrada
    </h1>
</div>

<div class="page" *ngIf="checkedGuid && checkedLoading">
    <!-- <app-header></app-header> -->
    <body class="container-page">
        
        <div class="body-page">
            <div class="title">
                <h2 *ngIf="healthUnitStruct">{{healthUnitStruct.healthUnitName}}</h2>
            </div>
            <div class="col-12 col-sm-6 col-md-8 body-page-info">
                <h1 class="title-redirect-page"><b>Seja Bem-Vindo!</b></h1>
                <h3 class="sub-title-redirect-page">Como podemos ajudá-lo?</h3>
                <img class="img-welcome-page" src="assets/images/welcome-health.png" />
                <div class="button-page-container col-12">
                    <button mat-flat-button color="primary" (click)="goSelfTriage()">
                        <span *ngIf="isLoading == false">Autotriagem</span>
                        <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
                    </button>
                    <button mat-flat-button color="primary" (click)="goNps()">
                        <span *ngIf="isLoading == false">Pesquisa de Satisfação</span>
                        <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
                    </button>
                </div>
            </div>
            <div class="col-12 col-sm-7 col-md-9 footer-page">
                <img class="footer-img" src="assets/images/logo-colorido-cinza.png" />
            </div>

        </div>
        
    </body>
</div>